import Authorization from "../../../utils/secure/Authorization";
import React, {useEffect, useState} from "react";
import Loading from "../../../utils/loading";
import {GetCategoriasProductos} from "../../../../services/categoriasServices";
import PullToRefresh from "react-simple-pull-to-refresh";
import NavBar from "../../../utils/nav/NavBar";
import NavMenu from "../../../utils/nav/NavMenu";
import ButtonAdd from "../../../utils/buttonAdd";
import CategoryEdit from "./categoryEdit";

const ProductCategories = () => {
    const [permissionChecked, setPermissionChecked] = useState(false);
    const [loading, setLoading] = useState(false);
    const [categoriasProductos, setCategoriasProductos] = useState([]);
    const [editingCategory, setEditingCategory] = useState();


    useEffect(() => {
        cargar();
    },[])

    const cargar = async () => {
        try {
            setLoading(true);
            let categoriasProductos = await GetCategoriasProductos();
            setCategoriasProductos(categoriasProductos);
        } catch (error) {
            alert(error);
        } finally {
            setLoading(false);
        }
    }
    
    if(editingCategory){
        return (
            <CategoryEdit
                category={editingCategory}
                onClose={() => setEditingCategory(undefined)}
                onSave={(categoria) => {
                    setEditingCategory(undefined);
                    cargar();
                }}
            />
        )
    }

    return (
        <div id="product-categories">
            {!permissionChecked && (
                <Authorization
                    permission="Catálogos/Productos/ABC"
                    onPermissionGranted={() => setPermissionChecked(true)}
                />
            )}

            <PullToRefresh onRefresh={cargar}>
                <div className="page-header">
                    <NavBar
                        title="Categorías de productos"
                        navButtonComponent={<NavMenu />}
                    />
                </div>

                <div className="page-list">
                    {categoriasProductos.map((categoria) => (
                        <div key={categoria.id} className="list-item"  onClick={() => setEditingCategory(categoria)}>
                            {categoria.nombre}
                        </div>
                    ))}
                </div>
            </PullToRefresh>

            {loading && <Loading/>}
        </div>
    )
}

export default ProductCategories;